@if (showMobileHomeExtras) {
  <!-- Accueil mobile : raccourcis vers les services -->
  <div class="container">
    <nav class="mobile-shortcuts" [attr.aria-label]="'mobileHome.shortcuts' | t">
      <a routerLink="/pres-de-moi" class="mobile-shortcut">
        <span class="mobile-shortcut-icon tone-teal"><mat-icon>near_me</mat-icon></span>{{ 'nearby.nav' | t }}
      </a>
      <a routerLink="/poster" [queryParams]="{ mode: 'inStore' }" class="mobile-shortcut">
        <span class="mobile-shortcut-icon tone-hot"><mat-icon>add_a_photo</mat-icon></span>{{ 'inStore.badge' | t }}
      </a>
      <a routerLink="/compte/club" class="mobile-shortcut">
        <span class="mobile-shortcut-icon tone-indigo"><mat-icon>redeem</mat-icon></span>{{ 'header.clubPoints' | t }}
      </a>
      <a routerLink="/compte/saved" class="mobile-shortcut">
        <span class="mobile-shortcut-icon tone-pink"><mat-icon>bookmark_border</mat-icon></span>{{ 'mobileHome.favorites' | t }}
      </a>
    </nav>
  </div>
}

@if (isPostBannerPage && !isSearchResult) {
  <div class="container">
    <app-post-deal-banner></app-post-deal-banner>
  </div>
}

@if (showMobileHomeExtras) {
  <div class="container">
    <app-hot-deals-sidebar layout="carousel"></app-hot-deals-sidebar>
  </div>
}

@if (isNearbyPage) {
  <div class="container">
    <app-nearby-panel (nearbySearch)="onNearbySearch($event)"></app-nearby-panel>
  </div>
}

@if (categoryDisplay) {
  <div class="container" style="padding-right: 0px; padding-left: 0px;">
    <nav mat-tab-nav-bar class="ms-nav-list-scroll" disablePagination="true" mat-align-tabs="center"
      backgroundColor="backgroundThemeColor">
      <mat-toolbar class="category-toolbar">
        <div>
          <mat-icon style="margin-right: 10px; vertical-align: sub;">{{categoryDisplayIcon}}</mat-icon>
          <span>{{ categoryKey ? (categoryKey | t) : categoryDisplay }}</span>
        </div>
        <!-- <span class="example-spacer"></span>
        <div *ngIf="!isDesktopDevice || mobile">
          <button *ngIf="!isFilter" (click)="isFilterChange()" mat-button><mat-icon>shopping_cart</mat-icon></button>
          <button *ngIf="isFilter" (click)="isFilterChange()" mat-button>
            <mat-icon>loyalty</mat-icon></button>
          </div>
          <div *ngIf="isFilter && (isDesktopDevice || !mobile)">
            <button mat-button><mat-icon>shopping_cart</mat-icon> Promotions</button>
            <span *ngIf="isDesktopDevice || !mobile">|</span>
            <button mat-button>
              <mat-icon>loyalty</mat-icon> Codes Promo</button>
            </div>
            <span *ngIf="isDesktopDevice || !mobile" (click)="isFilterChange()" [routerLinkActive]="'activeItem'">
              <mat-icon>filter_list</mat-icon>
            </span> -->
          </mat-toolbar>
        </nav>
        <br>
        </div>
      }


      @if (showSkeleton) {
        <div class="container">
          <div class="card card-padding">
            <div class="fb-item">
              <div class="first-section-wrapper">
        <ngx-skeleton-loader count="1" appearance="circle" [theme]="{
                    width: '120px',
                    height: '120px',
                    'border-radius': '10px'
                  }">
                </ngx-skeleton-loader>
                <div class="gravatar-title">
                  <div>
            <ngx-skeleton-loader [theme]="{
                      width: '90%',
                      'border-radius': '0',
                      'height': '25px',
                      'margin-top': '15px',
                      'margin-bottom': '10px',
                      'border-bottom': '2px solid rgba(0, 0, 0, 0.05)'
                    }"></ngx-skeleton-loader>
                  </div>
                  <div>
                    <ngx-skeleton-loader [theme]="{ width: '90%', 'border-radius': '0', height: '25px' }">
                    </ngx-skeleton-loader>
                  </div>
                  <div>
                    <ngx-skeleton-loader [theme]="{ width: '90%', 'border-radius': '0', height: '25px' }">
                    </ngx-skeleton-loader>
                  </div>
                </div>
                <div class="gravatar-title-detail">
                  <div>
            <ngx-skeleton-loader [theme]="{
                      width: '100%',
                      'border-radius': '0',
                      height: '45px',
                      'margin-bottom': '10px'
                    }"></ngx-skeleton-loader>
                  </div>
                  <div>
                    <ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '45px' }">
                    </ngx-skeleton-loader>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card card-padding" style="margin-top:5px">
            <div class="fb-item">
              <div class="first-section-wrapper">
        <ngx-skeleton-loader count="1" appearance="circle" [theme]="{
                    width: '120px',
                    height: '120px',
                    'border-radius': '10px'
                  }">
                </ngx-skeleton-loader>
                <div class="gravatar-title">
                  <div>
            <ngx-skeleton-loader [theme]="{
                      width: '90%',
                      'border-radius': '0',
                      'height': '25px',
                      'margin-top': '15px',
                      'margin-bottom': '10px',
                      'border-bottom': '2px solid rgba(0, 0, 0, 0.05)'
                    }"></ngx-skeleton-loader>
                  </div>
                  <div>
                    <ngx-skeleton-loader [theme]="{ width: '90%', 'border-radius': '0', height: '25px' }">
                    </ngx-skeleton-loader>
                  </div>
                  <div>
                    <ngx-skeleton-loader [theme]="{ width: '90%', 'border-radius': '0', height: '25px' }">
                    </ngx-skeleton-loader>
                  </div>
                </div>
                <div class="gravatar-title-detail">
                  <div>
            <ngx-skeleton-loader [theme]="{
                      width: '100%',
                      'border-radius': '0',
                      height: '45px',
                      'margin-bottom': '10px'
                    }"></ngx-skeleton-loader>
                  </div>
                  <div>
                    <ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '45px' }">
                    </ngx-skeleton-loader>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card card-padding" style="margin-top:5px">
            <div class="fb-item">
              <div class="first-section-wrapper">
        <ngx-skeleton-loader count="1" appearance="circle" [theme]="{
                    width: '120px',
                    height: '120px',
                    'border-radius': '10px'
                  }">
                </ngx-skeleton-loader>
                <div class="gravatar-title">
                  <div>
            <ngx-skeleton-loader [theme]="{
                      width: '90%',
                      'border-radius': '0',
                      'height': '25px',
                      'margin-top': '15px',
                      'margin-bottom': '10px',
                      'border-bottom': '2px solid rgba(0, 0, 0, 0.05)'
                    }"></ngx-skeleton-loader>
                  </div>
                  <div>
                    <ngx-skeleton-loader [theme]="{ width: '90%', 'border-radius': '0', height: '25px' }">
                    </ngx-skeleton-loader>
                  </div>
                  <div>
                    <ngx-skeleton-loader [theme]="{ width: '90%', 'border-radius': '0', height: '25px' }">
                    </ngx-skeleton-loader>
                  </div>
                </div>
                <div class="gravatar-title-detail">
                  <div>
            <ngx-skeleton-loader [theme]="{
                      width: '100%',
                      'border-radius': '0',
                      height: '45px',
                      'margin-bottom': '10px'
                    }"></ngx-skeleton-loader>
                  </div>
                  <div>
                    <ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '45px' }">
                    </ngx-skeleton-loader>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card card-padding" style="margin-top:5px">
            <div class="fb-item">
              <div class="first-section-wrapper">
        <ngx-skeleton-loader count="1" appearance="circle" [theme]="{
                    width: '120px',
                    height: '120px',
                    'border-radius': '10px'
                  }">
                </ngx-skeleton-loader>
                <div class="gravatar-title">
                  <div>
            <ngx-skeleton-loader [theme]="{
                      width: '90%',
                      'border-radius': '0',
                      'height': '25px',
                      'margin-top': '15px',
                      'margin-bottom': '10px',
                      'border-bottom': '2px solid rgba(0, 0, 0, 0.05)'
                    }"></ngx-skeleton-loader>
                  </div>
                  <div>
                    <ngx-skeleton-loader [theme]="{ width: '90%', 'border-radius': '0', height: '25px' }">
                    </ngx-skeleton-loader>
                  </div>
                  <div>
                    <ngx-skeleton-loader [theme]="{ width: '90%', 'border-radius': '0', height: '25px' }">
                    </ngx-skeleton-loader>
                  </div>
                </div>
                <div class="gravatar-title-detail">
                  <div>
            <ngx-skeleton-loader [theme]="{
                      width: '100%',
                      'border-radius': '0',
                      height: '45px',
                      'margin-bottom': '10px'
                    }"></ngx-skeleton-loader>
                  </div>
                  <div>
                    <ngx-skeleton-loader [theme]="{ width: '100%', 'border-radius': '0', height: '45px' }">
                    </ngx-skeleton-loader>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      }

      @if (showNoData) {
        <div>
          <div class="card-div">
            <!-- Offres des marchands partenaires cherchées : message seul, pour qu'elles restent visibles sur mobile -->
            <div class="no-data" [class.no-data-compact]="externalSearchQuery">
              @if (!externalSearchQuery) {
                <br>
                <br>
                <br>
                <img [src]="logoNodata" width="115" height="148" [alt]="logoNodata" />
              }
              @if (isNearbyPage) {
                <p>{{ 'nearby.empty' | t }}</p>
                <a class="nearby-empty-cta" routerLink="/poster" [queryParams]="{ mode: 'inStore' }">
                  <mat-icon>add_a_photo</mat-icon>{{ 'nearby.postInStore' | t }}
                </a>
              } @else {
              <p>
                {{ 'deals.noContent' | t }} <mat-icon>mood_bad</mat-icon>. {{ 'deals.noContentHint' | t }}
              </p>
              }
              @if (!externalSearchQuery) {
                <br>
                <br>
                <br>
                <br>
              }
                          </div>
                        </div>
                        @if (externalSearchQuery) {
                          <app-external-search-results [query]="externalSearchQuery"></app-external-search-results>
                        }
                      </div>
                    }

                    @if (products.length > 0) {
                      <div (scroll)="onScroll($event)" class="container"
                        [ngClass]="products.length == 1 ? 'container-one-deal' : 'container-many-deal' ">
                        <div class="view-toggle">
                          <button type="button" class="view-toggle-btn" [class.active]="viewMode === 'grid'"
                            (click)="setViewMode('grid')" [attr.aria-pressed]="viewMode === 'grid'"
                            [attr.aria-label]="'deals.viewGrid' | t" [title]="'deals.viewGrid' | t">
                            <mat-icon>grid_view</mat-icon>
                          </button>
                          <button type="button" class="view-toggle-btn" [class.active]="viewMode === 'list'"
                            (click)="setViewMode('list')" [attr.aria-pressed]="viewMode === 'list'"
                            [attr.aria-label]="'deals.viewList' | t" [title]="'deals.viewList' | t">
                            <mat-icon>view_list</mat-icon>
                          </button>
                        </div>
                        <!-- <mat-toolbar style="background-color:rgb(255, 255, 255)">
                        <div *ngIf="productCategory">
                          <form #f="ngForm">
                            <span class="p-input-icon-left p-mb-2 p-mb-md-0">
                              <input ngModel (input)="onSearchByCategory(f.value)" name='searchKeyWords' type="search" class="form-control"
                                placeholder="Recherche ici">
                            </span>
                          </form>
                        </div>
                        <div *ngIf="productAdvertiser">
                          <form #f="ngForm">
                            <span class="p-input-icon-left p-mb-2 p-mb-md-0">
                              <input ngModel (input)="onSearchByAdvertiser(f.value)" name='searchKeyWords' type="search" pInputText
                                placeholder="Recherche ici">
                            </span>
                          </form>
                        </div>
                        <div *ngIf="!productCategory && !productAdvertiser">
                          <form #f="ngForm">
                            <span class="p-input-icon-left p-mb-2 p-mb-md-0">
                              <input ngModel (input)="onSearch(f.value)" name='searchKeyWords' type="search" pInputText
                                placeholder="Recherche ici">
                            </span>
                          </form>
                        </div>
                      </mat-toolbar> -->
                      @if (viewMode === 'list') {
                      <div>
                        <div>
                          <ng-container>
                            @for (product of products; track product; let i = $index) {
                              <div>
                                @if (product.available) {
                                  <div class="card-div">
                                    <span hidden>@if (product.expirationDate) {
                                      <mat-icon>hourglass_empty</mat-icon>
                                    }
                                  {{calculateDiffEndDate(product)}}</span>
                                  <div>
                                    <div class="product-list-item" [class.disabled-contenct]="!product.available">
                                      @if (isDesktopDevice) {
                                        <div class="vote-badge">
                                          <button type="button" class="vote-btn" [class.vote-btn-active]="myVotes[product._id] === 1"
                                            (click)="onVote(product, 1, $event)" [attr.aria-label]="'deals.voteUp' | t">
                                            <mat-icon>thumb_up_alt</mat-icon>
                                          </button>
                                          <span class="vote-score" [ngClass]="'vote-score-' + getVoteLevel(product)">
                                            <mat-icon class="vote-fire">local_fire_department</mat-icon>{{getVoteScore(product)}}°
                                          </span>
                                          <button type="button" class="vote-btn" [class.vote-btn-active]="myVotes[product._id] === -1"
                                            (click)="onVote(product, -1, $event)" [attr.aria-label]="'deals.voteDown' | t">
                                            <mat-icon>thumb_down_alt</mat-icon>
                                          </button>
                                        </div>
                                      }
                                      <div class="demoWrapper" [ngClass]="isDesktopDevice ===true ? 'demoWrapper' : 'demoWrapperMobile'">
                                        <div class="container-img">
                                          @if (product.pictureUrl) {
                                            <img ngOptimizedImage (click)="onDetails(product, i)"
                                              [alt]="product.pictureUrl"
                                              [ngClass]="[dealBloced ===true ? 'product-img-expired' : 'product-img', product.selected ===false ? 'product-img-expired' : 'product-img'] "
                                              src={{product.pictureUrl}} [appImgFallback]="product.storedPictureUrl">
                                          }
                                          <div>
                                            @if (dealBloced ===true || product.selected ===false) {
                                              <span
                                              style="background-color: red;">{{ 'deals.expired' | t }}</span>
                                            }
                                            @if (dealWillBloced ===true) {
                                              <span style="color: rgb(255 106 0); white-space: nowrap;">@if (product.expirationDate) {
                                                <mat-icon
                                                >hourglass_empty</mat-icon>
                                              }{{ 'deals.expiresSoon' | t }}</span>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                      <!-- <div *ngIf="product.affiliateNetwork === 'Amazon'">
                                      <div [innerHTML]="product.pictureUrl" style="width: 100%;"></div>
                                    </div> -->
                                    @if (isDesktopDevice) {
                                      <div class="product-list-detail">
                                        <div class="toast-header-custom">
                                          <a routerLink="/"
                                            [ngClass]="[dealBloced ===true ? 'see-advertiser-expired' : 'see-advertiser', product.selected ===false ? 'see-advertiser-expired' : 'see-advertiser' ]"
                                            (click)="onFilterByAdvertiser(product.advertiserName)">
                                          {{product.advertiserName}}</a>
                                        <!-- {{product.expirationDate | date: 'dd/MM/yy'}}</span> -->
                                        <!-- <span *ngIf="product.expirationDate && product.addedDate && !mobile" class="thread-divider">|</span>
                                        <span *ngIf="product.addedDate && !mobile"> <mat-icon>history</mat-icon>
                                      {{calculateDiffAddDate(product.addedDate)}}</span> -->
                                      <strong class="me-auto"></strong>
                                      @if (product.percentageDiscount) {
                                        <span
                                        [ngClass]="[dealBloced ===true ? 'percentageDiscount-expired' : 'percentageDiscount', product.selected ===false ? 'percentageDiscount-expired' : 'percentageDiscount' ]">-{{product.percentageDiscount}}%</span>
                                      }
                                    </div>
                                    <div class="toast-body">
                                      <a routerLink="/"
                                        [ngClass]="[dealBloced ===true ? 'product-name-expired' : 'product-name', product.selected ===false ? 'product-name-expired' : 'product-name'] "
                                      (click)="onDetails(product, i)">{{product.name}}</a>
                                      @if (product.priceDiscount) {
                                        <span
                                          [ngClass]="[dealBloced ===true ? 'product-price-expired' : 'product-price', product.selected ===false ? 'product-price-expired' : 'product-price' ]"
                                        >{{product.priceDiscount}}€</span>
                                      }
                                      @if (product.price && product.price != product.priceDiscount) {
                                        <span
                                          [ngClass]="[dealBloced ===true ? 'oldPrice-expired' : 'oldPrice', product.selected ===false ? 'oldPrice-expired' : 'oldPrice' ]"
                                        class="product-price">{{product.price  | number : '1.2-2'}}€</span>
                                      }
                                      <div>
                                        <span title="description" (click)="onDetails(product)"
                                          [ngClass]="[dealBloced ===true ? 'description-expired' : 'description', product.selected ===false ? 'description-expired' : 'description' ]"
                                        [innerHTML]="product.description | slice:0:300"></span>
                                        @if (product.description && product.description.length > 30) {
                                          <span></span>
                                        }
                                      </div>
                                      <div class="card-footer-actions">
                                        <span class="comment-count" (click)="onDetails(product, i)">
                                          <mat-icon>forum</mat-icon>
                                          {{product.commentCount || 0}}
                                        </span>
                                        <button type="button" class="btn btn mat-button-toggle-appearance-standard position-relative share-button"
                                          (click)="sharePage(product)" [attr.aria-label]="'deals.share' | t">
                                          <mat-icon>share</mat-icon>
                                        </button>
                                        <button type="button" class="favorite-button" [class.favorite-button-active]="myFavorites[product._id]"
                                          (click)="onToggleFavorite(product, $event)" [attr.aria-label]="(myFavorites[product._id] ? 'deals.removeFavorite' : 'deals.saveFavorite') | t">
                                          <mat-icon>{{ myFavorites[product._id] ? 'bookmark' : 'bookmark_border' }}</mat-icon>
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                }
                                @if (products != undefined && isDesktopDevice) {
                                  <div class="product-list-action">
                                    @if (product.promotionCode && products[i].promotionCode != codePromotionCopied) {
                                      <button mat-button color="primary"
                                        (click)="onPromotionCodeDisplay(product)" type="button" icon="bi bi-scissors"
                                        class="btn btn position-relative promotion-code mat-select-value"
                                        [ngClass]="[dealBloced ===true ? 'mat-stroked-button-promocode-expired' : '', product.selected ===false ? 'mat-stroked-button-promocode-expired' : '' ]">{{ 'deals.showPromoCode' | t }}
                                      </button>
                                    }
                                    @if (product.promotionCode && copieCodePromotion===false && products[i].promotionCode === codePromotionCopied &&  promotionCodeDisplay) {
                                      <button type="button" mat-button color="primary"
                                        class="btn btn position-relative promotion-code" (click)="copyMessage(product.promotionCode)"
                                        [ngClass]="[dealBloced ===true ? 'mat-stroked-button-promocode-expired' : '', product.selected ===false ? 'mat-stroked-button-promocode-expired' : '' ]">
                                        <!-- <img [src]="logoScissors" width="20" height="22" [alt]="logoScissors" /> -->
                                        {{products[i].promotionCode}}
                                        <mat-icon>content_copy</mat-icon>
                                      </button>
                                    }
                                    @if (product.promotionCode && copieCodePromotion && products[i].promotionCode === codePromotionCopied &&  promotionCodeDisplay) {
                                      <button type="button" mat-button color="primary"
                                        class="btn btn position-relative promotion-code" (click)="copyMessage(product.promotionCode)"
                                        [ngClass]="[dealBloced ===true ? 'mat-stroked-button-promocode-expired' : '', product.selected ===false ? 'mat-stroked-button-promocode-expired' : '' ]">
                                        {{product.promotionCode}}
                                        @if (products[i].promotionCode===codePromotionCopied) {
                                          <span
                                            class="badge rounded-pill bg-light text-dark">{{ 'deals.copied' | t }}
                                          </span>
                                        }
                                      </button>
                                    }
                                    <!-- <a pButton class="href" (click)="incrementViewNumberProduct(product)" class="affiliateUrlBtn"
                                  href="{{product.affiliateUrl}}" icon="pi pi-shopping-cart" label="Voir le deal" target="_blank"></a> -->
                                  @if (product.inStore) {
                                    <a type="button" class="btn btn position-relative"
                                      [ngClass]="[dealBloced ===true ? 'mat-stroked-button-expired' : 'mat-stroked-button', product.selected ===false ? 'mat-stroked-button-expired' : 'mat-stroked-button' ]"
                                      (click)="onDetails(product, i)">
                                      <span class="button-text">{{ 'inStore.at' | t: { store: product.storeName || product.advertiserName } }}@if (product.distanceKm != null) { · {{ distanceLabel(product) }}}</span>
                                    </a>
                                  } @else {
                                  <a type="button" class="btn btn position-relative" href="{{product.affiliateUrl}}" target="_blank"
                                    [ngClass]="[dealBloced ===true ? 'mat-stroked-button-expired' : 'mat-stroked-button', product.selected ===false ? 'mat-stroked-button-expired' : 'mat-stroked-button' ]"
                                    (click)="incrementViewNumberProduct(product)">
                                    <!-- <mat-icon matBadge={{product.viewNumber}} matBadgeColor="warn"
                                    *ngIf="product.viewNumber >= 0 && product.viewNumber <= 999"
                                  [ngStyle]="{'color':'white', 'vertical-align': 'middle'}">visibility</mat-icon>
                                  <mat-icon matBadge="999" matBadgeColor="warn" *ngIf="product.viewNumber > 999"
                                  [ngStyle]="{'color':'white'}">visibility</mat-icon> -->
                                  <span class="button-text">{{ 'deals.seeOffer' | t }}</span>
                                </a>
                                  }
                              </div>
                            }
                            @if (!isDesktopDevice) {
                              <div class="product-list-detail-mobile">
                                <div class="toast-header-custom">
                                  <a routerLink="/"
                                    [ngClass]="[dealBloced ===true ? 'see-advertiser-expired' : 'see-advertiser', product.selected ===false ? 'see-advertiser-expired' : 'see-advertiser' ]"
                                    (click)="onFilterByAdvertiser(product.advertiser)">
                                  {{product.advertiser}}</a>
                                  <!-- <span *ngIf="product.expirationDate && product.addedDate && !mobile" class="thread-divider">|</span>
                                  <span *ngIf="product.addedDate && !mobile"> <mat-icon>history</mat-icon>
                                {{calculateDiffAddDate(product.addedDate)}}</span> -->
                                <div class="vote-badge-mobile">
                                  <button type="button" class="vote-btn" [class.vote-btn-active]="myVotes[product._id] === 1"
                                    (click)="onVote(product, 1, $event)" [attr.aria-label]="'deals.voteUp' | t">
                                    <mat-icon>arrow_drop_up</mat-icon>
                                  </button>
                                  <span class="vote-score" [ngClass]="'vote-score-' + getVoteLevel(product)">
                                    <mat-icon class="vote-fire">local_fire_department</mat-icon>{{getVoteScore(product)}}°
                                  </span>
                                  <button type="button" class="vote-btn" [class.vote-btn-active]="myVotes[product._id] === -1"
                                    (click)="onVote(product, -1, $event)" [attr.aria-label]="'deals.voteDown' | t">
                                    <mat-icon>arrow_drop_down</mat-icon>
                                  </button>
                                </div>
                                <strong class="me-auto"></strong>
                                @if (product.percentageDiscount) {
                                  <span
                                  [ngClass]="[dealBloced ===true ? 'percentageDiscount-expired' : 'percentageDiscount', product.selected ===false ? 'percentageDiscount-expired' : 'percentageDiscount' ]">-{{product.percentageDiscount}}%</span>
                                }
                              </div>
                              @if (!isDesktopDevice || mobile) {
                                <div class="toast-body">
                                  <div class="mat-grid-list">
                                    <div class="mat-grid-tile">
                                      <div>
                                        <a routerLink="/"
                                          [ngClass]="[dealBloced ===true ? 'product-name-expired' : 'product-name', product.selected ===false ? 'product-name-expired' : 'product-name' ]"
                                        (click)="onDetails(product, i)">{{product.name}}</a>
                                        @if (product.priceDiscount && products[i].promotionCode!= undefined && products[i].promotionCode != codePromotionCopied) {
                                          <span
                                          [ngClass]="[dealBloced ===true ? 'product-price-expired' : 'product-price', product.selected ===false ? 'product-price-expired' : 'product-price' ]">{{product.priceDiscount}}€</span>
                                        }
                                        @if (product.price && product.price != product.priceDiscount && products[i].promotionCode!= undefined && products[i].promotionCode != codePromotionCopied) {
                                          <span
                                          [ngClass]="[dealBloced ===true ? 'oldPrice-expired' : 'oldPrice', product.selected ===false ? 'oldPrice-expired' : 'oldPrice' ]">{{product.price  | number : '1.2-2' }}€</span>
                                        }
                                        @if (copieCodePromotion===false && products[i].promotionCode === codePromotionCopied &&  promotionCodeDisplay) {
                                          <button type="button" mat-button color="primary"
                                            class="btn btn position-relative promotion-code"
                                            (click)="copyMessage(product.promotionCode)">
                                            <!-- <img [src]="logoScissors" width="20" height="22" [alt]="logoScissors" /> -->
                                            {{products[i].promotionCode}}
                                            <mat-icon>content_copy</mat-icon>
                                          </button>
                                        }
                                        @if (copieCodePromotion && products[i].promotionCode === codePromotionCopied &&  promotionCodeDisplay) {
                                          <button type="button" mat-button color="primary"
                                            class="btn btn position-relative promotion-code"
                                            (click)="copyMessage(product.promotionCode)">
                                            {{product.promotionCode}}
                                            @if (products[i].promotionCode===codePromotionCopied) {
                                              <span
                                                class="badge rounded-pill bg-light text-dark">{{ 'deals.copied' | t }}
                                              </span>
                                            }
                                          </button>
                                        }
                                      </div>
                                      <!-- <a (click)="onDetails(product)" class="product-description">
                                      {{product.description | slice:0:30}} <span *ngIf="product.description.length > 30">...</span>
                                    </a> -->
                                  </div>
                                  @if (products != undefined && !isDesktopDevice || mobile) {
                                    <div class="mat-grid-tile_2">
                                      <div class="product-list-action-mobile">
                                        @if (product.inStore) {
                                          <a [attr.aria-label]="'inStore.badge' | t" (click)="onDetails(product, i)">
                                            <mat-icon
                                            [ngClass]="[dealBloced ===true ? 'mobile-affiliate-button-expired' : 'mobile-affiliate-button', product.selected ===false ? 'mobile-affiliate-button-expired' : 'mobile-affiliate-button' ]">storefront</mat-icon>
                                          </a>
                                        } @else {
                                        <a aria-label="advertiser" href="{{product.affiliateUrl}}" target="_blank"
                                          [routerLinkActive]="'activeItem'">
                                          <mat-icon
                                          [ngClass]="[dealBloced ===true ? 'mobile-affiliate-button-expired' : 'mobile-affiliate-button', product.selected ===false ? 'mobile-affiliate-button-expired' : 'mobile-affiliate-button' ]">launch</mat-icon>
                                        </a>
                                        }
                                        @if (product.promotionCode && products[i].promotionCode != codePromotionCopied) {
                                          <span
                                            (click)="onPromotionCodeDisplay(product)" type="button" icon="bi bi-scissors"
                                            class="scissors">
                                            <mat-icon
                                            [ngClass]="[dealBloced ===true ? 'mobile-affiliate-button-expired' : 'mobile-affiliate-button', product.selected ===false ? 'mobile-affiliate-button-expired' : 'mobile-affiliate-button' ]">content_cut</mat-icon>
                                          </span>
                                        }
                                      </div>
                                    </div>
                                  }
                                </div>
                                <div class="card-footer-actions">
                                  <span class="comment-count" (click)="onDetails(product, i)">
                                    <mat-icon>forum</mat-icon>
                                    {{product.commentCount || 0}}
                                  </span>
                                  <button type="button" class="btn btn mat-button-toggle-appearance-standard position-relative share-button"
                                    (click)="sharePage(product)" [attr.aria-label]="'deals.share' | t">
                                    <mat-icon>share</mat-icon>
                                  </button>
                                  <button type="button" class="favorite-button" [class.favorite-button-active]="myFavorites[product._id]"
                                    (click)="onToggleFavorite(product, $event)" [attr.aria-label]="(myFavorites[product._id] ? 'deals.removeFavorite' : 'deals.saveFavorite') | t">
                                    <mat-icon>{{ myFavorites[product._id] ? 'bookmark' : 'bookmark_border' }}</mat-icon>
                                  </button>
                                </div>
                              </div>
                            }
                          </div>
                        }
                      </div>
                    </div>
                    <hr class="dropdown-divider">
                  </div>
                }
              </div>
            }
          </ng-container>
        </div>
      </div>
                      } @else {
                      <div class="deals-grid">
                        @for (product of products; track product; let i = $index) {
                          @if (product.available) {
                            <div class="deal-card">
                              <span hidden>{{ calculateDiffEndDate(product) }}</span>

                              <div class="deal-media" [class.deal-media-expired]="dealBloced === true || product.selected === false"
                                (click)="onDetails(product, i)">
                                <div class="deal-media-top-row">
                                  <div class="deal-media-top-left">
                                    @if (product.percentageDiscount) {
                                      <span class="deal-badge-discount" [class.deal-badge-discount-expired]="dealBloced === true || product.selected === false"
                                        [style.background]="(dealBloced === true || product.selected === false) ? null : discountColor(product)">-{{ product.percentageDiscount }}%</span>
                                    }
                                  </div>
                                  @if (dealBloced === true || product.selected === false) {
                                    <span class="deal-badge-expired">{{ 'deals.expired' | t }}</span>
                                  } @else if (dealWillBloced === true) {
                                    <span class="deal-badge-soon">
                                      @if (product.expirationDate) {
                                        <mat-icon>hourglass_empty</mat-icon>
                                      }
                                      {{ 'deals.expiresSoon' | t }}
                                    </span>
                                  }
                                </div>
                                @if (product.pictureUrl) {
                                  <img ngOptimizedImage [alt]="product.pictureUrl" [appImgFallback]="product.storedPictureUrl"
                                    src={{product.pictureUrl}}>
                                } @else {
                                  <svg class="deal-media-mark" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                                    <rect x="4" y="5" width="16" height="12" rx="2"/>
                                    <path d="M8 19h8M12 17v2"/>
                                  </svg>
                                }
                                <div class="deal-vote-grid">
                                  <button type="button" class="vote-btn" [class.vote-btn-active]="myVotes[product._id] === 1"
                                    (click)="onVote(product, 1, $event)" [attr.aria-label]="'deals.voteUp' | t">
                                    <mat-icon>thumb_up_alt</mat-icon>
                                  </button>
                                  <span class="vote-score" [ngClass]="'vote-score-' + getVoteLevel(product)">
                                    <mat-icon class="vote-fire">local_fire_department</mat-icon>{{ getVoteScore(product) }}°
                                  </span>
                                  <button type="button" class="vote-btn" [class.vote-btn-active]="myVotes[product._id] === -1"
                                    (click)="onVote(product, -1, $event)" [attr.aria-label]="'deals.voteDown' | t">
                                    <mat-icon>thumb_down_alt</mat-icon>
                                  </button>
                                </div>
                              </div>

                              <div class="deal-body">
                                <a class="deal-source-row" [ngClass]="(dealBloced === true || product.selected === false) ? 'see-advertiser-expired' : 'see-advertiser'"
                                  (click)="onFilterByAdvertiser(product.advertiserName)">{{ product.advertiserName }}</a>

                                <a class="deal-name" [ngClass]="(dealBloced === true || product.selected === false) ? 'product-name-expired' : 'product-name'"
                                  (click)="onDetails(product, i)">{{ product.name }}</a>

                                <div class="deal-price-row">
                                  @if (product.priceDiscount) {
                                    <span [ngClass]="(dealBloced === true || product.selected === false) ? 'product-price-expired' : 'product-price'">{{ product.priceDiscount }}€</span>
                                  }
                                  @if (product.price && product.price != product.priceDiscount) {
                                    <span [ngClass]="(dealBloced === true || product.selected === false) ? 'oldPrice-expired' : 'oldPrice'">{{ product.price | number : '1.2-2' }}€</span>
                                  }
                                </div>

                                @if (product.promotionCode) {
                                  <div class="deal-code-row">
                                    <span class="promo-code-pill">{{ product.promotionCode }}</span>
                                    <button type="button" class="promo-code-cta"
                                      (click)="copyCodeAndOpenOffer(product, $event)">
                                      {{ 'deals.copyAndUseCode' | t }}
                                      <mat-icon>open_in_new</mat-icon>
                                    </button>
                                  </div>
                                }

                                @if (product.inStore) {
                                  <!-- Offre en magasin : pas de lien, l'enseigne mène à la fiche du deal -->
                                  <a type="button" class="deal-cta-store" [ngClass]="(dealBloced === true || product.selected === false) ? 'deal-cta-expired' : 'deal-cta'"
                                    (click)="onDetails(product, i)">
                                    <mat-icon>storefront</mat-icon>{{ 'inStore.at' | t: { store: product.storeName || product.advertiserName } }}@if (product.distanceKm != null) {<span class="deal-distance">· {{ distanceLabel(product) }}</span>}</a>
                                } @else {
                                  <a type="button" [ngClass]="(dealBloced === true || product.selected === false) ? 'deal-cta-expired' : 'deal-cta'"
                                    href="{{product.affiliateUrl}}" target="_blank"
                                    (click)="incrementViewNumberProduct(product)">{{ 'deals.seeOffer' | t }}</a>
                                }

                                <div class="card-footer-actions">
                                  <span class="comment-count" (click)="onDetails(product, i)">
                                    <mat-icon>forum</mat-icon>
                                    {{ product.commentCount || 0 }}
                                  </span>
                                  <button type="button" class="share-button" (click)="sharePage(product)" [attr.aria-label]="'deals.share' | t">
                                    <mat-icon>share</mat-icon>
                                  </button>
                                  <button type="button" class="favorite-button" [class.favorite-button-active]="myFavorites[product._id]"
                                    (click)="onToggleFavorite(product, $event)" [attr.aria-label]="(myFavorites[product._id] ? 'deals.removeFavorite' : 'deals.saveFavorite') | t">
                                    <mat-icon>{{ myFavorites[product._id] ? 'bookmark' : 'bookmark_border' }}</mat-icon>
                                  </button>
                                </div>
                              </div>
                            </div>
                          }
                          <!-- Accueil mobile : la colonne de droite du desktop, intercalée dans la 1re page du fil
                               (10 deals), après une rangée complète de 2 cartes, sur toute la largeur -->
                          @if (showMobileHomeExtras && i === 3) {
                            <div class="feed-widget"><app-sidebar-ad></app-sidebar-ad></div>
                          }
                          @if (showMobileHomeExtras && i === 5) {
                            <div class="feed-widget"><app-tech-news-sidebar></app-tech-news-sidebar></div>
                          }
                          @if (showMobileHomeExtras && i === 7) {
                            <div class="feed-widget"><app-partners-sidebar></app-partners-sidebar></div>
                          }
                        }
                      </div>
                      }
    </div>
  }
